import httpClient from '../httpClient';

export async function getAllTags() {
  try {
    const response = await httpClient.get(`/api/produtotag`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Produtos DAF: ' + error);
  }
}

// Definição do tipo para as tags (remova isso se não for necessário, já que agora estamos lidando com IDs)
// interface Tag {
//   valor: string;
// }

export async function saveTags(
  produtoDAFId: number,
  tagsSelecionadas: number[], // Mudar para number[]
): Promise<void> {
  try {
    const response = await httpClient.post(`/api/produtodaftag`, {
      produtoDAFId: produtoDAFId,
      tags: tagsSelecionadas,
    });
    console.log('Tags salvas com sucesso:', response.data);
  } catch (error) {
    if (error instanceof Error) {
      throw new Error('Erro ao salvar as tags: ' + error.message);
    } else {
      throw new Error('Erro ao salvar as tags: ocorreu um erro desconhecido');
    }
  }
}
